// Select all divs with the class 'clickable-div'
const clickableDivs = document.querySelectorAll('.main-variants button');
const mainProductDiv = document.querySelector('.main-product-price');

clickableDivs.forEach(div => {
    div.addEventListener('click', function() {
        const priceElement = this.querySelector('.main-product-variant');
        if (priceElement) {
            mainProductDiv.innerHTML = priceElement.innerHTML;
        }
    });
});